export default __webpack_public_path__ + "static/media/iconPlus.7064f714.svg";